<div class="wrapper">

    <div class="panel" *ngIf="!isKeyEnter">

        <!--[(ngModel)]="restream.key"-->
        <input nbInput [class.inputError]="emailError" [(ngModel)]="email" placeholder="Enter email"  type="text" />

        <div class="buttons">
            <button nbButton (click)="sendEmail()" [disabled]="emailDisabled"  status="primary">Next</button>
            <button nbButton (click)="onCancel.emit()" status="basic">Cancel</button>
        </div>
            
    </div>

    <div  class="panel" *ngIf="isKeyEnter">

        <input nbInput [class.inputError]="keyError"  [(ngModel)]="key"  placeholder="Enter code" type="text" />

        <div class="buttons">
            <button nbButton (click)="enter()" status="primary">Enter</button>
            <button nbButton (click)="cancel()" status="basic">Back</button>
        </div>
    </div>
    
</div>
